import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { BreadcrumbComponent } from "@shared/components/breadcrumb/breadcrumb.component";
import {
  AbstractControl,
  FormsModule,
  ReactiveFormsModule,
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  ValidationErrors,
  ValidatorFn,
  Validators
} from "@angular/forms";
import { MatButton, MatButtonModule } from "@angular/material/button";
import { MatFormField, MatFormFieldModule, MatLabel } from "@angular/material/form-field";
import { MatIcon } from "@angular/material/icon";
import { MatInput, MatInputModule } from "@angular/material/input";
import { MatAutocomplete, MatAutocompleteTrigger, MatOption } from "@angular/material/autocomplete";
import { MatSelect, MatSelectModule } from "@angular/material/select";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatOptionModule } from "@angular/material/core";
import { MatList, MatListItem } from "@angular/material/list";
import { MatTooltip } from "@angular/material/tooltip";
import { MatCheckboxModule } from "@angular/material/checkbox";
import {NgClass, NgForOf, NgIf, UpperCasePipe} from "@angular/common";

import { UserRole } from "@core/models/Enums/UserRole";
import { UserDetails } from "@core/models/UserDetails";
import { BusinessGroup } from "@core/models/BusinessGroup";
import { Branch } from "@core/models/Branch";
import { FederalEntity } from "@core/models/FederalEntity";
import { Settlement } from "@core/models/Settlement";
import { Allergy } from "@core/models/Allergy";
import { Molecule } from "@core/models/Molescule";
import { Patology } from "@core/models/Patology";
import { PatientDetails } from "@core/models/PatientDetails";
import { ImageSignature } from "@core/models/ImageSignature";
import { CreateUserResponse } from "@core/models/Http/Response/CreateUserResponse";
import { DefaultResponse } from "@core/models/Http/DefaultResponse";
import { CatalogsService } from "@core/http/catalogs.service";
import { PatientService } from "@core/http/patient.service";
import { CreateEditService } from "@core/http/create-edit-service";
import { ActivatedRoute, Router } from "@angular/router";
import { HttpErrorResponse } from '@angular/common/http';
import {debounceTime, distinctUntilChanged, finalize, firstValueFrom, of, Subject, tap} from "rxjs";
import { switchMap } from "rxjs/operators";
import { GeneralFunctionsService } from "@core/service/generalFunctions.service";
import { AuthManagementService } from "@core/service/auth-management.service";
import { HttpMesageHandlerService } from "@core/service/http-mesage-handler";
import { UppercaseNoAccentDirective } from "@shared/directives/uppercase-no-accent.directive";
import { REGEX } from "@shared/utils/regex.constants";
import Swal from "sweetalert2";
import { FileUploadComponent } from "@shared/components/file-upload/file-upload.component";
import { NgxMatIntlTelInputComponent } from "ngx-mat-intl-tel-input";
import { environment } from "@enviroment/environment";
import moment from "moment";
import { TutorService } from "@core/service/tutor.service";
import { MatDialog } from "@angular/material/dialog";
import {
  TutorCreateDialogComponent,
  TutorCreateDialogResult
} from "@shared/components/tutor-create-dialog/tutor-create-dialog.component";
import {
  TutorSelectDialogComponent,
  TutorSelectDialogResult,
  TutorSelectItem
} from "@shared/components/tutor-select-dialog/tutor-select-dialog.component";
import {UserService} from "@core/http/table-data-services/User.service";
import {RegionWordPipe} from "@core/pipes/region-word.pipe";
import {regionWord} from "@shared/utils/region-word.util";
import {GeneroVisible} from "@core/models/GeneroVisible";

/** ===== VALIDADORES ===== */
export const maxDateValidator = (max: Date): ValidatorFn => {
  return (control: AbstractControl): ValidationErrors | null => {
    const v = control.value;
    if (!v) return null;

    const d = new Date(v);
    if (isNaN(d.getTime())) return null;

    const dd = new Date(d.getFullYear(), d.getMonth(), d.getDate()).getTime();
    const mm = new Date(max.getFullYear(), max.getMonth(), max.getDate()).getTime();

    return dd > mm ? { maxDate: true } : null;
  };
};

type TutorAsignadoVm = {
  idUsuario: string;
  nombreCompleto: string;
  numeroIdentificacion?: string | null;
  email?: string | null;
  imagen?: string | null;
};

@Component({
  selector: 'app-patient-create-edit',
  standalone: true,
  imports: [
    BreadcrumbComponent,
    FormsModule,
    ReactiveFormsModule,

    MatButton,
    MatButtonModule,

    MatFormField,
    MatFormFieldModule,
    MatLabel,

    MatIcon,

    MatInput,
    MatInputModule,

    MatOption,
    MatOptionModule,

    MatSelect,
    MatSelectModule,

    MatAutocomplete,
    MatAutocompleteTrigger,

    MatList,
    MatListItem,

    MatTooltip,

    MatDatepickerModule,

    MatCheckboxModule,

    NgForOf,
    NgIf,
    NgClass,

    UppercaseNoAccentDirective,
    FileUploadComponent,
    NgxMatIntlTelInputComponent,
    RegionWordPipe,
    UpperCasePipe,
  ],
  templateUrl: './patient-create-edit.component.html',
  styleUrl: './patient-create-edit.component.scss'
})
export class PatientCreateEditComponent implements OnInit {
  readonly ID_TIPO_IDENTIFICACION_SIN_ASIGNAR = 0;
  readonly ID_TIPO_IDENTIFICACION_PASAPORTE = 1;
  readonly ID_TIPO_IDENTIFICACION_DOCUMENTO = 2;
  readonly ID_TIPO_IDENTIFICACION_REPRESENTANTE = 3;
  param: string | null = null;

  UserRole = UserRole;
  user: UserDetails;
  patient: PatientDetails;
  userImage?: string;

  private idTipoUsuarioPaciente: string | null = null;

  businessGroups: BusinessGroup[];
  branches: Branch[];
  federalEntity: FederalEntity[];

  allergies: Allergy[];
  molescules: Molecule[];
  patologies: Patology[];
  generosVisibles: GeneroVisible[];
  private cargandoEdicion = false;

  archive: ImageSignature;

  settlements: Settlement[];
  settlementSearch: string;

  searchAllergies: string;
  searchMolescule: string;
  searchPatologies: string;

  keyPressAllergy$ = new Subject();
  keyPressPatology$ = new Subject();
  keyPressMolecule$ = new Subject();

  patologiesNames: string[];
  molesculesNames: string[];
  allergiesNames: string[];

  isDoctor: boolean;
  isParticular: boolean;
  userData: any;
  tipoDeUsuario: any;

  showSucursalSelectForParticular: boolean = true;

  /** ===== TUTOR ===== */
  requiereTutor: boolean = false;
  tutorEmail: string = '';
  tutorNoEncontrado: boolean = false;
  tutorAsignado: TutorAsignadoVm | null = null;

  /** backend espera idUsuario aquí, aunque el campo se llame idTutor */
  idTutor: string | null = null;

  tutorEmailTouched = false;
  tutorSearchAttempted = false;

  /** evita abrir modales dobles */
  private isCreatingTutor = false;
  private isTutorModalOpen = false;

  tutorEmailAsignado: string = '';

  esMenorDeEdad: boolean = false;

  /** LOADINGS */
  tutorSearching: boolean = false;
  tutorAssigning: boolean = false;

  userForm: UntypedFormGroup;
  patientForm: UntypedFormGroup;
  archiveForm: UntypedFormGroup;

  maxBirthDate: Date = new Date();

  private originalImageBase64: string | null = null;
  private originalImageDataUrl: string | null = null;

  formControl = new UntypedFormControl('', [Validators.required]);

  preferredCountries: string[] = ['mx', 'es', 'us'];

  breadcrumbItems = [
    { label: 'PACIENTES', link: '/patient/patient-list' },
    { label: 'NUEVO PACIENTE' }
  ];

  private readonly PACIENTE_FALLBACK = 'assets/images/paciente.png';

  constructor(
    private catalogsService: CatalogsService,
    protected gfs: GeneralFunctionsService,
    private router: Router,
    private authManagement: AuthManagementService,
    private fb: UntypedFormBuilder,
    private route: ActivatedRoute,
    private patientService: PatientService,
    private tutorService: TutorService,
    private ceService: CreateEditService,
    private httpMsgHandler: HttpMesageHandlerService,
    private dialog: MatDialog,
    private cdr: ChangeDetectorRef,
    private userService: UserService,
  ) {
    this.user = new UserDetails({} as UserDetails);
    this.patient = new PatientDetails({} as PatientDetails);

    this.businessGroups = [];
    this.branches = [];
    this.federalEntity = [];
    this.settlements = [];
    this.settlementSearch = '';
    this.generosVisibles = [];

    this.searchAllergies = '';
    this.searchMolescule = '';
    this.searchPatologies = '';

    this.allergies = [];
    this.molescules = [];
    this.patologies = [];

    this.patologiesNames = [];
    this.molesculesNames = [];
    this.allergiesNames = [];

    this.userData = this.authManagement.userData();
    this.tipoDeUsuario = this.userData.IdTipoUsuario;
    this.isDoctor = this.authManagement.isUserDoctor();
    this.isParticular = this.authManagement.isUserParticular();

    this.route.paramMap.subscribe(params => {
      const param = params.get('param');
      this.param = param ? atob(param) : null;
    });

    this.archive = new ImageSignature({} as ImageSignature);

    this.userForm = this.createUserForm();
    this.patientForm = this.createPatientForm();
    this.archiveForm = this.createArchivesForm();

    const r = (environment as any)?.region?.toString().toUpperCase();
    this.preferredCountries = (r === 'ES') ? ['es', 'mx', 'us'] : ['mx', 'es', 'us'];
  }

  get isSpainRegion(): boolean {
    return String((environment as any)?.region ?? '').toUpperCase() === 'ES';
  }

  get documentoIdentidadLabel(): string {
    return this.isSpainRegion ? 'DNI' : 'INE';
  }

  get documentoRepresentanteLabel(): string {
    return this.isSpainRegion ? 'DNI DEL REPRESENTANTE' : 'INE DEL REPRESENTANTE';
  }

  get numeroIdentificacionReadonly(): boolean {
    const idTipo = Number(this.patientForm?.get('idTipoIdentificacion')?.value ?? 0);
    return idTipo === this.ID_TIPO_IDENTIFICACION_SIN_ASIGNAR || this.debeBloquearIdentificacionPorTutor();
  }

  private debeBloquearIdentificacionPorTutor(): boolean {
    return !!this.idTutor || !!this.tutorAsignado || this.requiereTutor || this.esMenorDeEdad;
  }

  private aplicarModoIdentificacionInicial(): void {
    const idTipoCtrl = this.patientForm.get('idTipoIdentificacion');
    const numeroCtrl = this.patientForm.get('numeroIdentificacion');

    if (!idTipoCtrl || !numeroCtrl) return;

    // ✅ si estamos editando y ya trae un tipo real, no lo pises
    if (this.param) {
      const tipoActual = Number(idTipoCtrl.value ?? 0);
      if (tipoActual && tipoActual !== this.ID_TIPO_IDENTIFICACION_SIN_ASIGNAR) {
        this.actualizarEstadoNumeroIdentificacion();
        return;
      }
    }

    if (this.debeBloquearIdentificacionPorTutor()) {
      this.setIdentificacionRepresentante(
        this.tutorAsignado?.numeroIdentificacion ?? this.patientForm.get('numeroIdentificacion')?.value ?? 'N/A'
      );
      return;
    }

    const idTipo = Number(idTipoCtrl.value ?? 0);

    if (idTipo === this.ID_TIPO_IDENTIFICACION_SIN_ASIGNAR) {
      numeroCtrl.patchValue('N/A', { emitEvent: false });
      numeroCtrl.disable({ emitEvent: false });
    } else {
      if ((numeroCtrl.value ?? '') === 'N/A') {
        numeroCtrl.patchValue('', { emitEvent: false });
      }
      numeroCtrl.enable({ emitEvent: false });
    }
  }

  onTipoIdentificacionChange(): void {
    const tipo = Number(this.patientForm?.get('idTipoIdentificacion')?.value ?? 0);
    const numeroCtrl = this.patientForm?.get('numeroIdentificacion');

    if (!numeroCtrl) return;

    // ✅ Durante carga de edición no resetear valores
    if (this.cargandoEdicion) {
      this.actualizarEstadoNumeroIdentificacion();
      return;
    }

    // ✅ Si hay tutor/representante, no dejar cambiar manualmente
    if (this.debeBloquearIdentificacionPorTutor()) {
      this.setIdentificacionRepresentante(
        this.tutorAsignado?.numeroIdentificacion ?? numeroCtrl.value ?? 'N/A'
      );
      return;
    }

    if (tipo === this.ID_TIPO_IDENTIFICACION_SIN_ASIGNAR) {
      numeroCtrl.setValue('N/A', { emitEvent: false });
      numeroCtrl.disable({ emitEvent: false });
      return;
    }

    numeroCtrl.enable({ emitEvent: false });

    const valorActual = (numeroCtrl.value ?? '').toString().trim().toUpperCase();
    if (valorActual === 'N/A') {
      numeroCtrl.setValue('', { emitEvent: false });
    }
  }

  private setIdentificacionRepresentante(numeroIdentificacion?: string | null): void {
    const numero = String(numeroIdentificacion ?? '').trim() || 'N/A';

    this.patientForm.patchValue({
      idTipoIdentificacion: this.ID_TIPO_IDENTIFICACION_REPRESENTANTE,
      numeroIdentificacion: numero
    }, { emitEvent: false });

    this.patientForm.get('numeroIdentificacion')?.disable({ emitEvent: false });
    this.patientForm.get('idTipoIdentificacion')?.disable({ emitEvent: false });
  }

  private resetIdentificacionSinTutor(): void {
    this.patientForm.get('idTipoIdentificacion')?.enable({ emitEvent: false });
    this.patientForm.patchValue({
      idTipoIdentificacion: this.ID_TIPO_IDENTIFICACION_SIN_ASIGNAR,
      numeroIdentificacion: 'N/A'
    }, { emitEvent: false });

    this.patientForm.get('numeroIdentificacion')?.disable({ emitEvent: false });
  }

  get resolvedPanelImage(): string {
    const raw =
      (this.archiveForm?.get('imagen')?.value as string | null | undefined) ??
      (this.userImage as string | null | undefined) ?? '';

    if (!raw) return this.PACIENTE_FALLBACK;

    const s = String(raw).trim();
    if (!s || s === 'null' || s === 'undefined') return this.PACIENTE_FALLBACK;
    if (s.startsWith('data:image/')) return s;
    if (s.startsWith('http://') || s.startsWith('https://') || s.startsWith('assets/')) return s;

    try {
      atob(s);
      return `data:image/png;base64,${s}`;
    } catch {
      return this.PACIENTE_FALLBACK;
    }
  }

  createArchivesForm(): UntypedFormGroup {
    return this.fb.group({
      idUsuario: [this.archive.idUsuario],
      imagen: [this.archive.imagen],
      firma: [this.archive.firma],
      pdf: [this.archive.pdf],
    });
  }

  ngOnInit(): void {
    this.setBreadcrumb();
    if (!this.isParticular) {
      this.getBusinessGroups();
    }
    this.getFederalEntity();
    this.getGenerosVisibles();

    /** obtener idTipoUsuario de "Paciente" */
    this.userService.getTiposUsuario().subscribe({
      next: (resp: DefaultResponse<any[]>) => {
        const match = (resp.data || []).find(t =>
          String(t.nombre || '').trim().toLowerCase() === 'paciente'
        );
        this.idTipoUsuarioPaciente = match ? String(match.idTipoUsuario) : null;
      },
      error: (err) => this.httpMsgHandler.handleMsg(err),
    });

    if (this.isParticular) {
      this.userForm.patchValue({
        idGEMP: this.userData?.IdGEMP ?? null
      }, { emitEvent: false });

      this.getBranchesForCurrentUser();
    }

    /** EDICIÓN */
    if (this.param) {
      this.getPatientDetails(this.param);
    }

    /** chips debounced */
    this.keyPressAllergy$
      .pipe(debounceTime(500), distinctUntilChanged(), tap(() => this.searchAllergiesByName()))
      .subscribe();

    this.keyPressPatology$
      .pipe(debounceTime(500), distinctUntilChanged(), tap(() => this.searchPatologiesByName()))
      .subscribe();

    this.keyPressMolecule$
      .pipe(debounceTime(500), distinctUntilChanged(), tap(() => this.searchMolesculesByName()))
      .subscribe();

    /** CP */
    this.userForm.get('settlementSearch')?.valueChanges
      .pipe(
        debounceTime(400),
        distinctUntilChanged(),
        tap((value: any) => {
          if (value && typeof value === 'string' && value.length === 5 && /^\d+$/.test(value)) {
            this.searchSettlements(value);
          } else if (typeof value === 'object') {
            // seleccionado
          } else {
            this.settlements = [];
          }
        })
      )
      .subscribe();

    this.patientForm.get('fechaNacimiento')?.valueChanges.subscribe(value => {
      const date = this.gfs.formatDate(value);
      const menor = this.calcularEdad(date) < 18;

      this.esMenorDeEdad = menor;

      if (menor) {
        this.requiereTutor = true;
        this.setIdentificacionRepresentante(
          this.tutorAsignado?.numeroIdentificacion ?? 'N/A'
        );
      } else {
        this.requiereTutor = false;

        if (!this.idTutor && !this.tutorAsignado) {
          if (this.param) {
            this.actualizarEstadoNumeroIdentificacion();
          } else {
            this.resetIdentificacionSinTutor();
          }
        }
      }
    });

    setTimeout(() => {
      this.aplicarModoIdentificacionInicial();
    }, 0);
  }

  private setBreadcrumb(): void {
    this.breadcrumbItems = [
      { label: 'PACIENTES', link: '/patient/patient-list' },
      { label: this.param ? 'EDITAR PACIENTE' : 'NUEVO PACIENTE' }
    ];
  }

  removeAccents(value: string): string {
    return value ? value.normalize('NFD').replace(/[\u0300-\u036f]/g, '') : value;
  }

  /** ===== CATALOGOS ===== */
  getBusinessGroups() {
    this.catalogsService.getBusinessGroups().subscribe({
      next: (res: DefaultResponse<BusinessGroup[]>) => this.businessGroups = [...res.data],
      error: (err: HttpErrorResponse) => this.httpMsgHandler.handleMsg(err)
    });
  }

  getFederalEntity() {
    this.catalogsService.getFederalEntitys().subscribe({
      next: (res: DefaultResponse<FederalEntity[]>) => {
        this.federalEntity = [...res.data];
        const val = this.patient?.idEntidadNacimiento;
        if (val != null) {
          this.patientForm?.patchValue({ idEntidadNacimiento: Number(val) }, { emitEvent: false });
        }
      },
      error: (err: HttpErrorResponse) => this.httpMsgHandler.handleMsg(err)
    });
  }

  getGenerosVisibles() {
    this.catalogsService.getGenerosVisibles().subscribe({
      next: (res: DefaultResponse<GeneroVisible[]>) => {
        this.generosVisibles = [...(res.data ?? [])].filter(x => x.activo);
      },
      error: (err: HttpErrorResponse) => this.httpMsgHandler.handleMsg(err)
    });
  }

  getBranchesByGemp(idGEMP = '') {
    if (!idGEMP) idGEMP = this.userForm.get('idGEMP')?.value;

    this.catalogsService.getBranchesByIdGEMP(idGEMP).subscribe({
      next: (res: DefaultResponse<Branch[]>) => this.branches = [...res.data],
      error: (err: HttpErrorResponse) => this.httpMsgHandler.handleMsg(err)
    });
  }

  getBranchesForCurrentUser() {
    this.catalogsService.getBranchesByAuthenticatedUser().subscribe({
      next: (res: DefaultResponse<Branch[]>) => {
        this.branches = [...(res.data ?? [])];

        // ✅ Si no hay sucursales para particular:
        // no mostramos el select y tomamos la sucursal del usuario logueado
        if (this.branches.length === 0) {
          this.showSucursalSelectForParticular = false;

          this.userForm.patchValue({
            idSucursal: this.userData?.IdSucursal ?? null
          }, { emitEvent: false });

          return;
        }

        // ✅ Si sí hay sucursales, mostramos el select
        this.showSucursalSelectForParticular = true;

        // ✅ Si solo hay una sucursal, la dejamos seleccionada
        if (this.branches.length === 1) {
          this.userForm.patchValue({
            idSucursal: this.branches[0].idSucursal
          }, { emitEvent: false });
        }

        // ✅ Si en edición ya trae una sucursal, mantenerla
        const currentIdSucursal = this.userForm.get('idSucursal')?.value;
        if (currentIdSucursal) {
          const exists = this.branches.some(b => b.idSucursal === currentIdSucursal);
          if (!exists) {
            this.userForm.patchValue({ idSucursal: null }, { emitEvent: false });
          }
        }
      },
      error: (err: HttpErrorResponse) => this.httpMsgHandler.handleMsg(err)
    });
  }

  /** ===== EDICION ===== */
  getPatientDetails(param: string) {
    this.cargandoEdicion = true;

    this.ceService.getpatientByIdUser(param).subscribe({
      next: (res: DefaultResponse<PatientDetails | PatientDetails[]>) => {
        const raw: any = Array.isArray(res.data) ? res.data[0] : res.data;
        if (!raw) {
          this.cargandoEdicion = false;
          return;
        }

        raw.email = this.removeAccents(raw.email);

        this.user = this.mapToUserDetails(raw);
        this.patient = this.mapToPatient(raw);

        this.userForm = this.createUserForm();
        this.patientForm = this.createPatientForm();

        this.patientForm.patchValue({
          idPaciente: this.patient.idPaciente,
          idUsuario: this.patient.idUsuario,
          fechaNacimiento: this.patient.fechaNacimiento,
          genero: this.patient.genero,
          idEntidadNacimiento: this.patient.idEntidadNacimiento != null
            ? Number(this.patient.idEntidadNacimiento)
            : null,
          idTipoIdentificacion: this.patient.idTipoIdentificacion ?? this.ID_TIPO_IDENTIFICACION_SIN_ASIGNAR,
          idGeneroVisible: this.patient.idGeneroVisible ?? null,
          alergias: this.patient.alergias ?? [],
          molecules: this.patient.molecules ?? [],
          patologias: this.patient.patologias ?? [],
          idTutor: this.idTutor ?? null
        }, { emitEvent: false });

        this.patientForm.get('numeroIdentificacion')?.setValue(
          this.patient.numeroIdentificacion ?? 'N/A',
          { emitEvent: false }
        );

        /** imagen */
        if (raw.imagen) {
          this.originalImageBase64 = String(raw.imagen);
          this.originalImageDataUrl = 'data:image/png;base64,' + this.originalImageBase64;
          this.userImage = this.originalImageDataUrl;
          this.archiveForm.patchValue({ imagen: null }, { emitEvent: false });
        } else {
          this.originalImageBase64 = null;
          this.originalImageDataUrl = null;
          this.userImage = this.PACIENTE_FALLBACK;
          this.archiveForm.patchValue({ imagen: null }, { emitEvent: false });
        }

        /** CP */
        this.settlementSearch = String(raw.codigoPostal || '').trim();
        if (this.settlementSearch.length === 5 && /^\d+$/.test(this.settlementSearch)) {
          this.searchSettlements(this.settlementSearch);
        } else {
          this.settlements = [];
          this.userForm.patchValue({ settlementSearch: null }, { emitEvent: false });
        }

        /** menor/mayor de edad inicial */
        const fechaNac = raw?.fechaNacimiento ?? null;
        if (fechaNac) {
          const menor = this.calcularEdad(fechaNac) < 18;
          this.esMenorDeEdad = menor;
          this.requiereTutor = menor;
        }

        // ✅ aplicar solo estado visual, sin resetear el valor cargado
        this.actualizarEstadoNumeroIdentificacion();

        const idPaciente = String(raw?.idPaciente ?? '').trim();
        if (idPaciente) {
          this.cargarTutorActualPorPaciente(idPaciente);
        } else {
          this.quitarTutor();
          this.cargandoEdicion = false;
          this.actualizarEstadoNumeroIdentificacion();
        }

        this.cdr.detectChanges();
      },
      error: (err: HttpErrorResponse) => {
        this.cargandoEdicion = false;
        this.httpMsgHandler.handleMsg(err);
      }
    });
  }

  private actualizarEstadoNumeroIdentificacion(): void {
    const tipo = Number(this.patientForm?.get('idTipoIdentificacion')?.value ?? 0);
    const numeroCtrl = this.patientForm?.get('numeroIdentificacion');

    if (!numeroCtrl) return;

    // ✅ Si hay tutor o aplica representante, domina esa lógica
    if (this.debeBloquearIdentificacionPorTutor()) {
      this.setIdentificacionRepresentante(
        this.tutorAsignado?.numeroIdentificacion ?? numeroCtrl.value ?? 'N/A'
      );
      return;
    }

    const esSinAsignar = tipo === this.ID_TIPO_IDENTIFICACION_SIN_ASIGNAR;

    if (esSinAsignar) {
      numeroCtrl.setValue('N/A', { emitEvent: false });
      numeroCtrl.disable({ emitEvent: false });
    } else {
      numeroCtrl.enable({ emitEvent: false });

      const valorActual = (numeroCtrl.value ?? '').toString().trim();
      if (!valorActual || valorActual.toUpperCase() === 'N/A') {
        numeroCtrl.setValue('', { emitEvent: false });
      }
    }
  }

  private cargarTutorActualPorPaciente(idPaciente: string): void {
    const id = String(idPaciente ?? '').trim();
    if (!id) {
      this.cargandoEdicion = false;
      return;
    }

    this.tutorNoEncontrado = false;
    this.tutorAssigning = true;

    this.tutorService.getTutorByPaciente(id)
      .pipe(finalize(() => this.tutorAssigning = false))
      .subscribe({
        next: (res: any) => {
          const tutor = this.mapTutorFromApi(res);

          if (!tutor) {
            // ✅ en edición, si no hay tutor, NO resetear identificación si ya venía del backend
            this.idTutor = null;
            this.patientForm.patchValue({ idTutor: null }, { emitEvent: false });
            this.tutorAsignado = null;
            this.tutorNoEncontrado = false;

            this.tutorEmailTouched = false;
            this.tutorSearchAttempted = false;
            this.tutorEmail = '';
            this.tutorEmailAsignado = '';

            this.cargandoEdicion = false;
            this.actualizarEstadoNumeroIdentificacion();
            this.cdr.detectChanges();
            return;
          }

          this.setTutorAsignado(tutor);

          // ✅ si ya trae tutor, mostramos sección sí o sí
          this.requiereTutor = true;

          this.cargandoEdicion = false;
          this.actualizarEstadoNumeroIdentificacion();
          this.cdr.detectChanges();
        },
        error: (err: HttpErrorResponse) => {
          this.httpMsgHandler.handleMsg(err);
          this.cargandoEdicion = false;
          this.actualizarEstadoNumeroIdentificacion();
          this.cdr.detectChanges();
        }
      });
  }
  /**
   * ✅ NORMALIZA RESPUESTA REAL DEL BACK:
   * {
   *  idTutorUsuario,
   *  idTutorPaciente,
   *  nombres,
   *  primerApellido,
   *  segundoApellido,
   *  email,
   *  ...
   * }
   */
  private mapTutorFromApi(res: any): TutorSelectItem | null {
    const data = res?.data ?? res ?? null;
    if (!data) return null;

    const first = Array.isArray(data) ? data[0] : data;
    if (!first) return null;

    const pick = (...keys: string[]) => {
      for (const k of keys) {
        const v = first?.[k];
        if (v !== undefined && v !== null && String(v).trim() !== '') {
          return String(v).trim();
        }
      }
      return '';
    };

    const idUsuario = pick(
      'tutor_IdUsuario', 'Tutor_IdUsuario',
      'tutorIdUsuario', 'TutorIdUsuario',
      'idTutorUsuario', 'IdTutorUsuario',
      'idUsuarioTutor', 'IdUsuarioTutor',
      'idUsuario', 'IdUsuario',
      'idTutor', 'IdTutor'
    );

    if (!idUsuario) return null;

    const nombres = pick(
      'tutor_Nombres', 'Tutor_Nombres',
      'tutorNombres', 'TutorNombres',
      'nombres', 'Nombres'
    );

    const ap1 = pick(
      'tutor_PrimerApellido', 'Tutor_PrimerApellido',
      'tutorPrimerApellido', 'TutorPrimerApellido',
      'primerApellido', 'PrimerApellido'
    );

    const ap2 = pick(
      'tutor_SegundoApellido', 'Tutor_SegundoApellido',
      'tutorSegundoApellido', 'TutorSegundoApellido',
      'segundoApellido', 'SegundoApellido'
    );

    const nombreCompleto =
      pick('nombreCompleto', 'NombreCompleto')
      || `${nombres} ${ap1} ${ap2}`.replace(/\s+/g, ' ').trim()
      || 'TUTOR ASIGNADO';

    const email = pick(
      'tutor_Email', 'Tutor_Email',
      'tutorEmail', 'TutorEmail',
      'email', 'Email',
      'correo', 'Correo'
    ).toLowerCase();

    const numeroIdentificacion = pick(
      'numeroIdentificacion',
      'NumeroIdentificacion',
      'tutor_NumeroIdentificacion',
      'Tutor_NumeroIdentificacion'
    );

    return {
      idUsuario,
      nombreCompleto,
      email: email || null,
      numeroIdentificacion: numeroIdentificacion || null
    };
  }

  /** ===== CP ===== */
  searchSettlements(cp: string) {
    if (!cp) { this.settlements = []; return; }

    this.catalogsService.getSettlementByPostalCode(cp).subscribe({
      next: (res: DefaultResponse<Settlement[]>) => {
        this.settlements = [...res.data];

        if (this.settlements.length === 0) {
          this.userForm.patchValue({ settlementSearch: null }, { emitEvent: false });
        }

        const idAsentamientoActual = this.userForm.get('idAsentamiento')?.value || this.user.idAsentamiento;
        if (idAsentamientoActual) {
          const selected = this.settlements.find(s => s.idAsentamiento === idAsentamientoActual);
          if (selected) {
            this.userForm.patchValue({
              settlementSearch: selected,
              idAsentamiento: selected.idAsentamiento
            });
          }
        }
      },
      error: (err) => this.httpMsgHandler.handleMsg(err)
    });
  }

  displayFn(settlement: Settlement): string {
    return settlement && settlement.asentamiento ? settlement.asentamiento : '';
  }

  setSelectedSettlement(value: Settlement): void {
    this.user.idAsentamiento = value ? value.idAsentamiento : undefined;
    this.userForm.patchValue({ idAsentamiento: this.user.idAsentamiento });
  }

  onSettlementBlur() {
    const val = this.userForm.get('settlementSearch')?.value;
    if (!val || typeof val !== 'object' || !val.idAsentamiento) {
      this.userForm.patchValue({ settlementSearch: null }, { emitEvent: false });
    }
  }

  /** ===== FORMS ===== */
  createUserForm(): UntypedFormGroup {
    return this.fb.group({
      idUsuario: [this.user?.idUsuario ? this.user.idUsuario : null],
      usr: [this.user.usr, [Validators.required, Validators.pattern(REGEX.user)]],
      idTipoUsuario: [this.tipoDeUsuario],
      idGEMP: [this.user.idGEMP],
      idSucursal: [this.user.idSucursal],
      nombres: [this.user.nombres, [Validators.required, Validators.pattern(REGEX.text)]],
      primerApellido: [this.user.primerApellido, [Validators.required, Validators.pattern(REGEX.text)]],
      segundoApellido: [this.user.segundoApellido, [Validators.required, Validators.pattern(REGEX.text)]],
      idAsentamiento: [this.user.idAsentamiento],
      domicilio: [this.user.domicilio, [Validators.required]],
      movil: [this.user.movil, [Validators.required]],
      email: [this.user.email, [Validators.required, Validators.pattern(REGEX.correo)]],
      settlementSearch: [this.settlementSearch],
    });
  }

  createPatientForm(): UntypedFormGroup {
    return this.fb.group({
      ...(this.param && { idPaciente: [this.patient.idPaciente] }),
      genero: [this.patient.genero, [Validators.required]],
      idGeneroVisible: [this.patient.idGeneroVisible ?? null],
      idUsuario: [this.patient.idUsuario],
      fechaNacimiento: [this.patient.fechaNacimiento, [Validators.required, maxDateValidator(this.maxBirthDate)]],
      idTipoIdentificacion: [
        this.patient.idTipoIdentificacion ?? this.ID_TIPO_IDENTIFICACION_SIN_ASIGNAR,
        Validators.required
      ],
      numeroIdentificacion: [
        { value: this.patient.numeroIdentificacion ?? 'N/A', disabled: true },
        Validators.required
      ],
      idEntidadNacimiento: [
        this.patient.idEntidadNacimiento != null ? Number(this.patient.idEntidadNacimiento) : null,
        Validators.required
      ],
      alergias: [this.patient.alergias],
      molecules: [this.patient.molecules],
      patologias: [this.patient.patologias],

      // ✅ idTutor real que espera el backend
      idTutor: [this.idTutor ?? null],
    });
  }

  /** ===== MAPEOS ===== */
  mapToUserDetails(response: any): UserDetails {
    if (this.isParticular) {
      this.getBranchesForCurrentUser();
    } else {
      this.getBranchesByGemp(response.idGEMP);
    }

    const u = new UserDetails({} as UserDetails);
    u.idUsuario = response.idUsuario;
    u.password = response.password;
    u.nombres = response.nombres;
    u.primerApellido = response.primerApellido;
    u.segundoApellido = response.segundoApellido;
    u.movil = response.movil;
    u.email = response.email;
    u.domicilio = response.domicilio;
    u.idAsentamiento = response.idAsentamiento;
    u.nombreAsentamiento = response.asentamiento;
    u.idCP = response.idCP;
    u.codigoPostal = response.codigoPostal;
    u.idMunicipio = response.idMunicipio;
    u.municipio = response.municipio;
    u.idGEMP = response.idGEMP;
    u.usr = response.usr;
    u.idSucursal = response.idSucursal;
    return u;
  }

  mapToPatient(response: any): PatientDetails {
    const p = new PatientDetails({} as PatientDetails);

    p.genero = response.genero ?? '';
    p.idPaciente = response.idPaciente ?? null;
    p.idUsuario = response.idUsuario ?? null;
    p.fechaNacimiento = response.fechaNacimiento ?? null;
    p.idEntidadNacimiento = response.idEntidadNacimiento ?? null;
    p.idTipoIdentificacion = response.idTipoIdentificacion ?? this.ID_TIPO_IDENTIFICACION_SIN_ASIGNAR;
    p.numeroIdentificacion = response.numeroIdentificacion ?? 'N/A';
    p.idGeneroVisible = response.idGeneroVisible ?? null;
    p.generoVisible = response.generoVisible ?? null;
    p.alergias = (response.alergias ?? []) as any[];
    p.molecules = (response.molecules ?? []) as any[];
    p.patologias = (response.patologias ?? []) as any[];

    this.idTutor = null;

    return this.setDisplayEditPatient(p);
  }

  private toE164(val: any): string {
    if (!val) return '';
    if (typeof val === 'string') return val.trim();
    if (val?.e164) return String(val.e164).trim();
    if (val?.e164Number) return String(val.e164Number).trim();
    if (val?.number) return String(val.number).trim();
    return '';
  }

  /** ===== FECHAS ===== */
  formatDateMoment(date: any, opt: number) {
    const fechaNacimientoMoment = moment(date);
    if (!fechaNacimientoMoment.isValid()) {
      throw new Error('El valor de fechaNacimiento no es valido.');
    }
    switch (opt) {
      case 1: return fechaNacimientoMoment.startOf('day').format('YYYY-MM-DDTHH:mm:ss.SSS');
      default: return '';
    }
  }

  calcularEdad(fechaNacimiento: string | Date): number {
    const hoy = new Date();
    const nac = new Date(fechaNacimiento);
    let edad = hoy.getFullYear() - nac.getFullYear();
    const m = hoy.getMonth() - nac.getMonth();
    if (m < 0 || (m === 0 && hoy.getDate() < nac.getDate())) edad--;
    return edad;
  }

  /** ===== CHIPS ===== */
  setDisplayEditPatient(patient: PatientDetails): PatientDetails {
    const toIdsAndNames = <T extends Record<string, any>>(
      raw: any[] | undefined,
      idKey: keyof T,
      nameKey: keyof T
    ): { ids: string[]; names: string[] } => {
      if (!Array.isArray(raw) || raw.length === 0) return { ids: [], names: [] };

      if (typeof raw[0] === 'string' || typeof raw[0] === 'number') {
        return { ids: (raw as (string | number)[]).map(x => String(x)), names: [] };
      }

      const ids: string[] = [];
      const names: string[] = [];
      (raw as T[]).forEach((o) => {
        if (o) {
          const idVal = o[idKey];
          const nameVal = o[nameKey];
          if (idVal !== undefined && idVal !== null) ids.push(String(idVal));
          if (nameVal !== undefined && nameVal !== null && String(nameVal).trim() !== '') {
            names.push(String(nameVal));
          }
        }
      });
      return { ids, names };
    };

    const a = toIdsAndNames<any>(patient.alergias as any[], 'idAllergy', 'nameAllergy');
    const m = toIdsAndNames<any>(patient.molecules as any[], 'idMolecule', 'nameMolecule');
    const p = toIdsAndNames<any>(patient.patologias as any[], 'idCIM10', 'nameCIM10');

    patient.alergias = a.ids;
    patient.molecules = m.ids;
    patient.patologias = p.ids;

    this.allergiesNames = a.names;
    this.molesculesNames = m.names;
    this.patologiesNames = p.names;

    return patient;
  }

  removeMolecule(index: number): void {
    (this.molesculesNames ??= []).splice(index, 1);
    (this.patient.molecules ??= []).splice(index, 1);
  }
  removeAllergy(index: number): void {
    (this.allergiesNames ??= []).splice(index, 1);
    (this.patient.alergias ??= []).splice(index, 1);
  }
  removePatology(index: number): void {
    (this.patologiesNames ??= []).splice(index, 1);
    (this.patient.patologias ??= []).splice(index, 1);
  }

  /** ===== BUSQUEDAS ===== */
  searchAllergiesByKeyPress(event: Event) { this.keyPressAllergy$.next(event); }
  searchMolesculesByKeyPress(event: Event) { this.keyPressMolecule$.next(event); }
  searchPatologiesByKeyPress(event: Event) { this.keyPressPatology$.next(event); }

  displayFnAllergy(allergy: Allergy): string { return allergy && allergy.nameAllergy ? allergy.nameAllergy : ''; }
  displayFnMolescules(molescule: Molecule): string { return molescule && molescule.nameMolecule ? molescule.nameMolecule : ''; }
  displayFnPatologies(patology: Patology): string { return patology && patology.nameCIM10 ? patology.nameCIM10 : ''; }

  setSelectedAllergy(value: Allergy) {
    if (!value) return;
    if (!this.patient.alergias) this.patient.alergias = [];
    const exists = this.patient.alergias.find((a) => a == String(value.idAllergy));
    if (!exists) {
      this.patient.alergias.push(String(value.idAllergy));
      this.allergiesNames.push(value.nameAllergy);
      this.searchAllergies = '';
    }
  }

  setSelectedPatology(value: Patology) {
    if (!value) return;
    if (!this.patient.patologias) this.patient.patologias = [];
    const exists = this.patient.patologias.find((a) => a == String(value.idCIM10));
    if (!exists) {
      this.patient.patologias.push(String(value.idCIM10));
      this.patologiesNames.push(value.nameCIM10);
      this.searchPatologies = '';
    }
  }

  setSelectedMolecule(value: Molecule) {
    if (!value) return;
    if (!this.patient.molecules) this.patient.molecules = [];
    const exists = this.patient.molecules.find((a) => a == String(value.idMolecule));
    if (!exists) {
      this.patient.molecules.push(String(value.idMolecule));
      this.molesculesNames.push(value.nameMolecule);
      this.searchMolescule = '';
    }
  }

  searchAllergiesByName() {
    if (!this.searchAllergies) { this.allergies = []; return; }
    this.catalogsService.getAllergiesByName(this.searchAllergies).subscribe({
      next: (res: DefaultResponse<Allergy[]>) => this.allergies = [...res.data],
      error: (err: HttpErrorResponse) => this.httpMsgHandler.handleMsg(err)
    });
  }

  searchMolesculesByName() {
    if (!this.searchMolescule) { this.molescules = []; return; }
    this.catalogsService.getMolesculesByName(this.searchMolescule).subscribe({
      next: (res: DefaultResponse<Molecule[]>) => this.molescules = [...res.data],
      error: (err: HttpErrorResponse) => this.httpMsgHandler.handleMsg(err)
    });
  }

  searchPatologiesByName() {
    if (!this.searchPatologies) { this.patologies = []; return; }

    const fechaNac = this.patientForm.get('fechaNacimiento')?.value;
    if (!fechaNac) {
      Swal.fire({
        icon: 'warning',
        title: 'ADVERTENCIA',
        text: 'DEBES INGRESAR LA FECHA DE NACIMIENTO DEL PACIENTE PARA BUSCAR PATOLOGIAS.'
      }).then();
      this.patologies = [];
      return;
    }

    const edad = this.calcularEdad(fechaNac);
    const genero = this.patientForm.get('genero')?.value;

    this.catalogsService.getPatologiessByName(this.searchPatologies, edad, genero).subscribe({
      next: (res: DefaultResponse<Patology[]>) => this.patologies = [...res.data],
      error: (err: HttpErrorResponse) => this.httpMsgHandler.handleMsg(err)
    });
  }

  // =========================================================
  // ======================= TUTOR ===========================
  // =========================================================

  /** ===== TUTOR: BUSCAR POR EMAIL ===== */
  buscarTutorPorEmail(): void {
    const email = (this.tutorEmail ?? '').trim().toLowerCase();
    this.tutorNoEncontrado = false;
    this.tutorSearchAttempted = true;

    if (!email) {
      Swal.fire({
        icon: 'warning',
        title: 'CORREO REQUERIDO',
        text: 'INGRESA EL CORREO DEL TUTOR.'
      }).then();
      return;
    }

    if (!REGEX.correo.test(email)) {
      Swal.fire({
        icon: 'warning',
        title: 'CORREO INVALIDO',
        text: 'INGRESA UN CORREO VALIDO.'
      }).then();
      return;
    }

    this.tutorSearching = true;

    this.tutorService.getTutorByEmail(email)
      .pipe(finalize(() => this.tutorSearching = false))
      .subscribe({
        next: async (res: any) => {
          const listRaw = res?.data ?? res ?? [];
          const list = Array.isArray(listRaw) ? listRaw : (listRaw ? [listRaw] : []);

          // 0 resultados => crear tutor
          if (list.length === 0) {
            this.quitarTutor();
            this.tutorNoEncontrado = true;
            this.openTutorModalSafely(email);
            return;
          }

          const pick = (obj: any, keys: string[]): string => {
            for (const key of keys) {
              const value = obj?.[key];
              if (value !== undefined && value !== null && String(value).trim() !== '') {
                return String(value).trim();
              }
            }
            return '';
          };

          const options: TutorSelectItem[] = list
            .map((x: any) => {
              const idUsuario = pick(x, [
                'tutor_IdUsuario',
                'Tutor_IdUsuario',
                'tutorIdUsuario',
                'TutorIdUsuario',
                'idTutorUsuario',
                'IdTutorUsuario',
                'idUsuarioTutor',
                'IdUsuarioTutor',
                'idUsuario',
                'IdUsuario',
                'idTutor',
                'IdTutor'
              ]);

              if (!idUsuario) return null;

              const nombres = pick(x, [
                'tutor_Nombres',
                'Tutor_Nombres',
                'tutorNombres',
                'TutorNombres',
                'nombres',
                'Nombres'
              ]);

              const primerApellido = pick(x, [
                'tutor_PrimerApellido',
                'Tutor_PrimerApellido',
                'tutorPrimerApellido',
                'TutorPrimerApellido',
                'primerApellido',
                'PrimerApellido'
              ]);

              const segundoApellido = pick(x, [
                'tutor_SegundoApellido',
                'Tutor_SegundoApellido',
                'tutorSegundoApellido',
                'TutorSegundoApellido',
                'segundoApellido',
                'SegundoApellido'
              ]);

              const nombreCompleto =
                pick(x, ['nombreCompleto', 'NombreCompleto'])
                || `${nombres} ${primerApellido} ${segundoApellido}`.replace(/\s+/g, ' ').trim()
                || 'TUTOR';

              const emailTutor = pick(x, [
                'tutor_Email',
                'Tutor_Email',
                'tutorEmail',
                'TutorEmail',
                'email',
                'Email',
                'correo',
                'Correo'
              ]).toLowerCase() || email;

              const numeroIdentificacion = pick(x, [
                'numeroIdentificacion',
                'NumeroIdentificacion',
                'tutor_NumeroIdentificacion',
                'Tutor_NumeroIdentificacion'
              ]);

              return {
                idUsuario,
                nombreCompleto,
                email: emailTutor || null,
                numeroIdentificacion: numeroIdentificacion || null
              } as TutorSelectItem;
            })
            .filter(Boolean) as TutorSelectItem[];

          if (options.length === 0) {
            this.quitarTutor();
            this.tutorNoEncontrado = true;
            this.openTutorModalSafely(email);
            return;
          }

          if (options.length === 1) {
            const tutorCompleto = await this.completarTutorConDatos(options[0]);
            await this.confirmarYAsignarTutor(tutorCompleto);
            return;
          }

          this.abrirModalSeleccionTutor(email, options);
        },
        error: (err: HttpErrorResponse) => {
          this.quitarTutor();
          this.httpMsgHandler.handleMsg(err);
        }
      });
  }

  private async completarTutorConDatos(tutor: TutorSelectItem): Promise<TutorSelectItem> {
    const idUsuario = String(tutor?.idUsuario ?? '').trim();
    if (!idUsuario) return tutor;

    try {
      const res: any = await firstValueFrom(this.ceService.getpatientByIdUser(idUsuario));
      const data = Array.isArray(res?.data) ? res.data[0] : (res?.data ?? null);

      const numeroIdentificacion =
        data?.numeroIdentificacion ??
        data?.NumeroIdentificacion ??
        null;

      const imagenRaw =
        data?.imagen ??
        data?.Imagen ??
        null;

      const imagen = imagenRaw
        ? (String(imagenRaw).startsWith('data:image/')
          ? String(imagenRaw)
          : `data:image/png;base64,${imagenRaw}`)
        : null;

      return {
        ...tutor,
        numeroIdentificacion: numeroIdentificacion ? String(numeroIdentificacion).trim() : null,
        imagen
      };
    } catch {
      return tutor;
    }
  }

  /** modal select */
  private abrirModalSeleccionTutor(email: string, options: TutorSelectItem[]): void {
    const ref = this.dialog.open(TutorSelectDialogComponent, {
      width: '720px',
      maxWidth: '95vw',
      disableClose: true,
      autoFocus: false,
      data: { email, options }
    });

    ref.afterClosed().subscribe(async (result: TutorSelectDialogResult | null) => {
      if (!result?.selected) return;
      await this.confirmarYAsignarTutor(result.selected);
    });
  }

  /** confirm antes de asignar */
  private async confirmarYAsignarTutor(tutor: TutorSelectItem): Promise<void> {
    const nombre = tutor.nombreCompleto || 'ESTE TUTOR';

    this.tutorAssigning = true;
    try {
      const resp = await Swal.fire({
        icon: 'question',
        title: 'CONFIRMAR',
        html: `¿ESTAS SEGURO QUE QUIERES ASIGNAR A <b>${nombre}</b> COMO TUTOR?`,
        showCancelButton: true,
        confirmButtonText: 'SI, ASIGNAR',
        cancelButtonText: 'CANCELAR'
      });

      if (!resp.isConfirmed) return;

      this.setTutorAsignado(tutor);
    } finally {
      this.tutorAssigning = false;
    }
  }

  private setTutorAsignado(tutor: TutorSelectItem): void {
    const idUsuario = String(tutor?.idUsuario ?? '').trim();
    if (!idUsuario) return;

    this.tutorAsignado = {
      idUsuario,
      nombreCompleto: (tutor?.nombreCompleto || 'TUTOR ASIGNADO').trim(),
      numeroIdentificacion: String(tutor?.numeroIdentificacion ?? '').trim() || null,
      email: String(tutor?.email ?? this.tutorEmail ?? '').trim().toLowerCase() || null,
      imagen: String(tutor?.imagen ?? '').trim() || null
    };

    this.tutorEmailAsignado = String(tutor?.email ?? this.tutorEmail ?? '').trim().toLowerCase();
    this.tutorEmail = this.tutorEmailAsignado || this.tutorEmail;

    this.idTutor = idUsuario;

    if (this.patientForm?.get('idTutor')) {
      this.patientForm.patchValue({ idTutor: idUsuario }, { emitEvent: false });
      this.patientForm.get('idTutor')?.updateValueAndValidity({ emitEvent: false });
    }

    this.setIdentificacionRepresentante(this.tutorAsignado.numeroIdentificacion ?? 'N/A');

    this.tutorNoEncontrado = false;

    this.cdr.detectChanges();
  }

  /** evita abrir el modal varias veces */
  private openTutorModalSafely(email: string): void {
    if (this.isTutorModalOpen) return;
    this.isTutorModalOpen = true;

    this.abrirModalCrearTutor(email);

    setTimeout(() => this.isTutorModalOpen = false, 800);
  }

  abrirModalCrearTutor(emailPrefill?: string): void {
    if (this.isCreatingTutor) return;
    this.isCreatingTutor = true;

    const email = (emailPrefill ?? this.tutorEmail ?? '').trim().toLowerCase();

    const ref = this.dialog.open(TutorCreateDialogComponent, {
      width: '980px',
      maxWidth: '95vw',
      disableClose: true,
      autoFocus: false,
      data: { email }
    });

    ref.afterClosed().subscribe((result: TutorCreateDialogResult | null) => {
      this.isCreatingTutor = false;
      this.isTutorModalOpen = false;

      if (!result) return;

      this.setTutorAsignado({
        idUsuario: result.idUsuario,
        nombreCompleto: result.nombreCompleto,
        email: result.email,
        numeroIdentificacion: result.numeroIdentificacion,
        imagen: result.imagen ?? null
      });
    });
  }

  quitarTutor(): void {
    this.idTutor = null;
    this.patientForm.patchValue({ idTutor: null }, { emitEvent: false });
    this.tutorAsignado = null;
    this.tutorNoEncontrado = false;

    this.tutorEmailTouched = false;
    this.tutorSearchAttempted = false;
    this.tutorEmail = '';
    this.tutorEmailAsignado = '';

    if (this.param) {
      this.actualizarEstadoNumeroIdentificacion();
      this.cdr.detectChanges();
      return;
    }

    if (!this.esMenorDeEdad && !this.requiereTutor) {
      this.resetIdentificacionSinTutor();
    } else {
      this.setIdentificacionRepresentante('N/A');
    }

    this.cdr.detectChanges();
  }

  /** ===== GUARDAR ===== */
  private patchStaticPatientData(): void {
    this.patientForm.patchValue({
      alergias: this.patient.alergias,
      molecules: this.patient.molecules,
      patologias: this.patient.patologias,
    });
  }

  private patchFormattedDates(): void {
    const fechaNacimiento = this.patientForm.get('fechaNacimiento')?.value;
    if (fechaNacimiento) {
      this.patientForm.patchValue(
        { fechaNacimiento: this.formatDateMoment(fechaNacimiento, 1) },
        { emitEvent: false }
      );
    }
  }

  private prepareUserData(): any | null {
    const userData = this.userForm.getRawValue();
    const selectedSettlement = userData.settlementSearch as Settlement;

    if (!selectedSettlement?.idAsentamiento) {
      Swal.fire({
        icon: 'error',
        title: regionWord('COLONIA REQUERIDA'),
        text: regionWord('DEBES SELECCIONAR UNA COLONIA DE LA LISTA PARA CONTINUAR.')
      }).then();
      return null;
    }

    userData.idAsentamiento = selectedSettlement.idAsentamiento;
    userData.movil = this.toE164(this.userForm.get('movil')?.value);
    delete userData.settlementSearch;

    userData.idTipoUsuario = this.idTipoUsuarioPaciente;

    userData.idGEMP = (this.isDoctor || this.isParticular)
      ? this.userData.IdGEMP
      : this.userForm.get('idGEMP')?.value;

    userData.idSucursal = this.isDoctor
      ? this.userData.IdSucursal
      : this.isParticular
        ? (this.userForm.get('idSucursal')?.value || this.userData.IdSucursal)
        : this.userForm.get('idSucursal')?.value;

    userData.password = null;

    return userData;
  }

  private patchFormsWithUserId(res: DefaultResponse<CreateUserResponse>): void {
    const userId = res.data;
    if (!this.param) {
      this.patientForm.patchValue({ idUsuario: userId });
      this.archiveForm.patchValue({ idUsuario: userId });
    } else {
      this.archiveForm.patchValue({ idUsuario: this.param });
    }
  }

  public confirmAdd(): void {
    this.patchStaticPatientData();
    this.patchFormattedDates();

    const idTutor = this.patientForm.get('idTutor')?.value;

    // menor: obligatorio
    if (this.esMenorDeEdad && !idTutor) {
      Swal.fire({
        icon: 'warning',
        title: 'TUTOR OBLIGATORIO',
        text: 'EL PACIENTE ES MENOR DE EDAD. DEBES ASIGNAR UN TUTOR.'
      }).then();
      return;
    }

    // mayor: opcional (si no requiere tutor, aseguramos null)
    if (!this.esMenorDeEdad && !this.requiereTutor) {
      this.patientForm.patchValue({ idTutor: null }, { emitEvent: false });
    } else if (!this.esMenorDeEdad && this.requiereTutor && !idTutor) {
      Swal.fire({
        icon: 'warning',
        title: 'TUTOR REQUERIDO',
        text: 'ACTIVASTE "SE REQUIERE TUTOR". DEBES ASIGNAR UNO.'
      }).then();
      return;
    }

    const userData = this.prepareUserData();
    if (!userData) return;

    let lastResponse: any = null;

    this.userService.createUpdateUser(userData).pipe(
      tap(res => this.patchFormsWithUserId(res)),
      switchMap(() => this.patientService.createUpdatePatient(this.patientForm.getRawValue())),
      tap((res: any) => { lastResponse = res; }),
      switchMap(() => this.uploadImagesIfNeeded())
    ).subscribe({
      next: () => {
        if (lastResponse) this.httpMsgHandler.handleMsg(lastResponse);
        this.router.navigate(['patient/patient-list']);
      },
      error: err => this.httpMsgHandler.handleMsg(err)
    });
  }

  /** ===== SUBIR IMAGEN ===== */
  private uploadImagesIfNeeded() {
    const imgVal = this.archiveForm.get('imagen')?.value as any;
    const idUsuario = this.archiveForm.get('idUsuario')?.value as string | null;

    if (!idUsuario) return of(null);
    if (!imgVal) return of(null);

    const toPlainBase64 = (v?: string | null) => {
      if (!v) return '';
      const i = v.indexOf('base64,');
      return i >= 0 ? v.substring(i + 'base64,'.length) : v;
    };

    const base64BytesSize = (b64: string): number => {
      if (!b64) return 0;
      const cleaned = b64.replace(/\s/g, '');
      const padding = cleaned.endsWith('==') ? 2 : cleaned.endsWith('=') ? 1 : 0;
      return Math.max(0, Math.floor((cleaned.length * 3) / 4) - padding);
    };

    if (typeof imgVal === 'object' && (imgVal.base64 || imgVal.dataUrl)) {
      const base64Raw = toPlainBase64(imgVal.base64 ?? imgVal.dataUrl ?? '');
      if (!base64Raw) return of(null);

      const upsert = {
        idUsuario,
        tipo: 1,
        blobBase64: base64Raw,
        contentType: imgVal.contentType ?? 'image/jpeg',
        bytesSize: Number(imgVal.bytesSize ?? base64BytesSize(base64Raw)),
        widthPx: imgVal.widthPx ?? null,
        heightPx: imgVal.heightPx ?? null,
        hashSha256Base64: imgVal.hashSha256Base64 ?? null,
      };

      if (!upsert.bytesSize || upsert.bytesSize <= 0) return of(null);

      return this.userService.uploadUsuarioAsset(upsert);
    }

    if (typeof imgVal === 'string') {
      const base64Raw = toPlainBase64(imgVal);
      if (!base64Raw) return of(null);

      const bytes = base64BytesSize(base64Raw);
      if (!bytes || bytes <= 0) return of(null);

      const upsert = {
        idUsuario,
        tipo: 1,
        blobBase64: base64Raw,
        contentType: imgVal.startsWith('data:image/png') ? 'image/png' : 'image/jpeg',
        bytesSize: bytes,
        widthPx: null,
        heightPx: null,
        hashSha256Base64: null,
      };

      return this.userService.uploadUsuarioAsset(upsert);
    }

    return of(null);
  }

  getErrorMessage(): string {
    return this.formControl.hasError('required')
      ? 'CAMPO OBLIGATORIO'
      : this.formControl.hasError('email')
        ? 'CORREO INVALIDO'
        : 'ERROR';
  }

  get showTutorRequiredError(): boolean {
    if (!this.esMenorDeEdad) return false;
    if (this.tutorAsignado || this.idTutor) return false;
    return this.tutorEmailTouched || this.tutorSearchAttempted;
  }

  onTutorEmailBlur(): void {
    this.tutorEmailTouched = true;
  }
}
